import { Suspense } from "react";
import { Catcher } from "../base/Catcher.js";
import { RetryButton } from "../base/Retrier.js";

export const LOADING_CARD = <article className="card pad-none height-3x effect-waiting" />;

export const ERROR_CARD = (
	<article className="card pad-2x color-quiet">
		<p>Unknown error</p>
		<RetryButton mods="button-quiet" />
	</article>
);

export const PRIVATE_CARD = (
	<article className="card pad-2x color-quiet">
		<p>Private content</p>
		<RetryButton mods="button-quiet" />
	</article>
);

export const MISSING_CARD = (
	<article className="card pad-2x color-quiet">
		<p>Deleted content</p>
		<RetryButton mods="button-quiet" />
	</article>
);

/**
 * Load a card.
 * - Wrapped in `<Catcher>` so child cards can throw errors.
 * - Wrapped in `<Suspense>` so child cards can throw promises.
 */
export function CardLoader({ children }: { children: React.ReactNode }): React.ReactElement {
	return (
		<Catcher error={ERROR_CARD} forbidden={PRIVATE_CARD} required={MISSING_CARD}>
			<Suspense fallback={LOADING_CARD}>{children}</Suspense>
		</Catcher>
	);
}
